export default {
  data () {
    return {
      columns: [
        {
          title: 'id',
          type: 'index'
        }, {
          title: '角色名称',
          key: 'name'
        }, {
          title: '角色描述',
          key: 'descript'
        }, {
          title: '状态',
          render: (h, { index, row }) => {
            let { status } = row // 'Y' 'N'
            let booleanStatus = status === 'Y'
            return (
              <div>
                <i-switch disabled size="large" v-model={booleanStatus}>
                  <span slot="open">启用</span>
                  <span slot="close">禁用</span>
                </i-switch>
              </div>
            )
          }
        }
      ]
    }
  }
}
